import { render, staticRenderFns } from "./AuthAccessor.vue?vue&type=template&id=240517f0&scoped=true"
import script from "./AuthAccessor.vue?vue&type=script&lang=js"
export * from "./AuthAccessor.vue?vue&type=script&lang=js"
import style0 from "./AuthAccessor.vue?vue&type=style&index=0&id=240517f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240517f0",
  null
  
)

export default component.exports